import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-6 col-md-4 col-lg-3"
}
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = {
  key: 0,
  class: "q-mt-sm"
}
const _hoisted_4 = { key: 1 }


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessServiceTreeElement',
  props: {
  service: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  }
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  const _component_business_service_tree_element = _resolveComponent("business-service-tree-element", true)!

  return (__props.depth === 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(__props.service.name), 1)
        ]),
        (__props.service.children)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.service.children, (subService) => {
                return (_openBlock(), _createBlock(_component_business_service_tree_element, {
                  key: subService.id,
                  depth: __props.depth + 1,
                  service: subService
                }, null, 8, ["depth", "service"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.depth === 0 ? 'h4' : 'div'), null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.service.name), 1)
          ]),
          _: 1
        }))
      ]))
}
}

})